import { Popup } from "antd-mobile";

import CustomNavBar from "../CustomNavBar";
import styles from "./style.module.scss";
import "./styles.scss";

const CustomPopup = (
  {
    title = "",
    onClose = () => {},
    children = null,
    visible = false,
    destroyOnClose = false,
    afterClose = () => {},
    right = null,
  },
  ...props
) => {
  return (
    <Popup
      className="custom-drawer-popup"
      {...props}
      visible={visible}
      destroyOnClose={destroyOnClose}
      afterClose={afterClose}
      position="right"
      bodyStyle={{
        width: "100vw",
        height: "calc(var(--vh, 1vh) * 100)",
        backgroundColor: "var(--main-bg)",
      }}
    >
      <CustomNavBar onBack={onClose} right={right}>
        {title}
      </CustomNavBar>
      <div className={styles.container}>{children}</div>
    </Popup>
  );
};

export default CustomPopup;
